module.exports = __webpack_public_path__ + "static/award-filecluster-9775b1b09ac4501ddffbec908950b6fb.png";